import { ScheduleSettingsMode } from './../../../enums/screen-settings-mode.enum';
import moment from 'moment';

export class ScheduleDTO {
  public ScheduleType: ScheduleSettingsMode;

  public AllDay = false;
  public StartTime: string = null;
  public EndTime: string = null;
  public StartDate: string = null;
  public EndDate: string = null;

  public Monday = false;
  public Tuesday = false;
  public Wednesday = false;
  public Thursday = false;
  public Saturday = false;
  public Friday = false;
  public Sunday = false;

  protected transformDateToString(
    date: string | Date = new Date(),
    formatType: string = 'YYYY-MM-DD'
  ): string {
    if (date) {
      const currentDate =
        this.ScheduleType === ScheduleSettingsMode.Range
          ? new Date(date)
          : new Date();

      return moment(currentDate).format(formatType);
    }

    return null;
  }

  protected transformTimeToString(value: string | Date): string {
    if (value) {
      const date = moment(value, 'HH:mm:ss').toDate();
      return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    }

    return null;
  }
}
